import React, { useMemo, useState } from 'react';
import NavBar from '../components/NavBar';
import { CarData } from '../components/CarData';

function CarShow() {
  const [filters, setFilters] = useState({ search: '', body: 'all', minPrice: '', maxPrice: '', sort: 'default' });
  const bodyTypes = [...new Set(CarData.map((car) => car.body))];

  const updateFilter = (event) => {
    const { name, value } = event.target;
    setFilters((current) => ({ ...current, [name]: value }));
  };

  const filteredCars = useMemo(() => {
    const normalizedSearch = filters.search.trim().toLocaleLowerCase('tr-TR');
    const min = filters.minPrice === '' ? 0 : Number(filters.minPrice);
    const max = filters.maxPrice === '' ? Infinity : Number(filters.maxPrice);

    const result = CarData.filter((car) => {
      const matchesSearch = car.name.toLocaleLowerCase('tr-TR').includes(normalizedSearch);
      const matchesBody = filters.body === 'all' || car.body === filters.body;
      const price = Number(car.price);
      return matchesSearch && matchesBody && price >= min && price <= max;
    });

    return [...result].sort((a, b) => {
      if (filters.sort === 'price-asc') return Number(a.price) - Number(b.price);
      if (filters.sort === 'price-desc') return Number(b.price) - Number(a.price);
      if (filters.sort === 'year-desc') return Number(b.year) - Number(a.year);
      return a.id - b.id;
    });
  }, [filters]);

  const clearFilters = () => setFilters({ search: '', body: 'all', minPrice: '', maxPrice: '', sort: 'default' });

  return (
    <div className="page-shell">
      <NavBar />
      <main className="content-shell section">
        <div className="section-heading">
          <div><p className="eyebrow">Car Gallery koleksiyonu</p><h1 className="section-title">Her yol için bir karakter</h1></div>
          <p className="section-copy">SUV'den coupe'ye, şehir otomobilinden hibrit modellere kadar özenle seçilmiş araçlar.</p>
        </div>
        <section className="filter-panel" aria-label="Araç filtreleri">
          <div className="filter-search">
            <label htmlFor="car-search">Model ara</label>
            <div className="search-field">
              <span aria-hidden="true">⌕</span>
              <input id="car-search" name="search" type="search" value={filters.search} onChange={updateFilter} placeholder="BMW, Audi, Toyota..." />
            </div>
          </div>
          <div className="filter-field">
            <label htmlFor="body-filter">Kasa tipi</label>
            <select id="body-filter" name="body" value={filters.body} onChange={updateFilter}>
              <option value="all">Tüm kasalar</option>
              {bodyTypes.map((body) => <option value={body} key={body}>{body}</option>)}
            </select>
          </div>
          <div className="filter-price">
            <label>Fiyat aralığı (€)</label>
            <div className="price-inputs">
              <input aria-label="Minimum fiyat" name="minPrice" type="number" min="0" step="1000" value={filters.minPrice} onChange={updateFilter} placeholder="Min" />
              <span>—</span>
              <input aria-label="Maksimum fiyat" name="maxPrice" type="number" min="0" step="1000" value={filters.maxPrice} onChange={updateFilter} placeholder="Maks" />
            </div>
          </div>
          <div className="filter-field">
            <label htmlFor="sort-filter">Sıralama</label>
            <select id="sort-filter" name="sort" value={filters.sort} onChange={updateFilter}>
              <option value="default">Önerilen</option>
              <option value="price-asc">Fiyat: Artan</option>
              <option value="price-desc">Fiyat: Azalan</option>
              <option value="year-desc">En yeni</option>
            </select>
          </div>
          <div className="filter-summary">
            <strong>{filteredCars.length}</strong><span>araç bulundu</span>
            <button type="button" onClick={clearFilters}>Filtreleri temizle</button>
          </div>
        </section>
        <div className="catalog-grid">
          {filteredCars.map((car) => (
            <article className="car-card" key={car.id}>
              <div className="car-card-image"><img src={car.img} alt={car.name} loading="lazy" /></div>
              <div className="car-card-body">
                <span className="car-card-meta">{car.year} · {car.body}</span>
                <h2>{car.name}</h2>
                <div className="car-card-footer"><span>{car.Cylinder} · {car.Color}</span><strong>€{Number(car.price).toLocaleString('tr-TR')}</strong></div>
              </div>
            </article>
          ))}
        </div>
        {filteredCars.length === 0 && (
          <div className="empty-state">
            <span>⌕</span><h2>Eşleşen araç bulunamadı</h2>
            <p>Arama veya fiyat aralığını değiştirerek tekrar deneyin.</p>
            <button type="button" className="primary-button" onClick={clearFilters}>Filtreleri temizle</button>
          </div>
        )}
      </main>
    </div>
  );
}

export default CarShow;
